document.addEventListener('DOMContentLoaded', function () {
    let current_page = 1;
    let records_per_page = 10;

    let articles = document.querySelectorAll(".author-content__blogs-article");
    let numPages = Math.ceil(articles.length / records_per_page);

    function changePage(page) {
        if (page < 1) page = 1;
        if (page > numPages) page = numPages;

        articles.forEach((article, i) => {
            article.style.display = i < (page-1)*records_per_page || i >= page*records_per_page ? 'none' : 'block';
        });

        let pageNumbers = document.getElementById("page-numbers");
        pageNumbers.innerHTML = "";
        for (let i = 1; i <= numPages; i++) {
            let btn = document.createElement("button");
            btn.innerHTML = i;
            if (i == current_page) {
                btn.classList.add('active');
            }
            btn.addEventListener('click', function () { current_page = i; changePage(i); });
            pageNumbers.appendChild(btn);
        }
    }

    changePage(1);
});
